import {Component} from '@angular/core';

// Services
import {AppService} from '../../services/app-service';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:StartArrowCmp'));

/**
 * Start arrow renders only once. After being dismissed it gets locked out.
 */
@Component({
    selector: 'start-arrow-cmp',
    template: require('./start-arrow.cmp.html'),
    styles: [String(require('./start-arrow.cmp.scss'))],
    host: {
        class: 'start-arrow',
        '(document:click)': 'onClick($event)'
    }
})
export class StartArrowCmp {
    
    constructor (
        // private _startArrowElementRef: ElementRef,
        private _appService: AppService
    ) {
        // 'Construct start arrow component' );
    }

    
    ngOnInit() {
        // 'Initialise start arrow component' );
    }

    
    onClick(event) {
        debugOff( 'Start arrow onClick' );
        this._appService.hideStartArrow();
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/components/layout/start-arrow.cmp.ts